<div class="progress-container">
  <div [style.width.%]="progress" class="progress-bar"></div>
</div>
<p class="progress-bar-text">{{ progress }}% Complete</p>
